import { render, staticRenderFns } from "./openClosedDateItem.vue?vue&type=template&id=ec5fe752"
import script from "./openClosedDateItem.js?vue&type=script&lang=js&external"
export * from "./openClosedDateItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports